const foldChar = (ch) => ch.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
const foldStr = (s) => {
  let out = "";
  const str = String(s ?? "");
  for (let i = 0; i < str.length; i++) out += foldChar(str[i]);
  return out;
};

// Resalta en color los términos de `query` encontrados dentro de `text` (tolerante a acentos).
export default function Highlight({ text, query, className = "bg-[#C75B28]/25 text-[#8a3f1c] rounded-[3px] px-0.5" }) {
  const t = String(text ?? "");
  const q = (query || "").trim();
  if (!t || !q) return <>{t}</>;
  const folded = foldStr(t);
  const tokens = [...new Set(foldStr(q).split(/\s+/).filter(Boolean))];
  if (!tokens.length) return <>{t}</>;

  const marks = new Array(t.length).fill(false);
  for (const tok of tokens) {
    let i = 0;
    while ((i = folded.indexOf(tok, i)) !== -1) {
      for (let j = i; j < i + tok.length; j++) marks[j] = true;
      i += tok.length;
    }
  }

  const parts = [];
  let buf = "";
  let cur = marks[0];
  const push = (on, s) => {
    if (!s) return;
    parts.push(on ? <mark key={parts.length} className={className}>{s}</mark> : <span key={parts.length}>{s}</span>);
  };
  for (let k = 0; k < t.length; k++) {
    if (marks[k] === cur) buf += t[k];
    else { push(cur, buf); buf = t[k]; cur = marks[k]; }
  }
  push(cur, buf);
  return <>{parts}</>;
}
